import { render, staticRenderFns } from "./DownloadCenter.vue?vue&type=template&id=02afdf64&scoped=true&"
import script from "./DownloadCenter.vue?vue&type=script&lang=js&"
export * from "./DownloadCenter.vue?vue&type=script&lang=js&"
import style0 from "./DownloadCenter.vue?vue&type=style&index=0&id=02afdf64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02afdf64",
  null
  
)

export default component.exports